module.exports = __webpack_public_path__ + "files/e9c71d023146f1351720e236c6e48507.png";